import { Form, Formik } from 'formik'
import React, { useState, useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Loading from 'custom/assets/loaders/Loading'
import InputError from '../../components/InputError/InputError'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoInput from '../../components/NeoInput/NeoInput'
import * as Yup from 'yup'
import DashboardService from '../../services/dashboard.service'
import BeneficiaryTransferService from '../../services/beneficiary-transfers.service'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'
import { useHistory } from 'react-router-dom'
import {
  MENU_SIDEBAR_KEYS,
  SIDENAV_KEYS,
  RECIPTS_KEYS,
  VALIDATION_MESSAGES,
} from '../../utils/translation-constants'
import AccountsService from '../../services/accounts.service'
import moment from 'moment'

export default function BIStatement() {
  const { t } = useTranslation()
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [stage, setStage] = useState(0)
  const [reportList, setReportList] = useState([])
  const formatList = ['xlsx', 'pdf']
  const history = useHistory()
  const [accounts, setAccounts] = useState([])
  // const accounts = useSelector(accountsSelector) || []

  useEffect(() => {
    fetchAccounts()
    getAllRefNumbers()
  }, [])

  const fetchAccounts = useCallback(async () => {
    try {
      const response = await AccountsService.getAllAccounts()
      if (response.status === 200) {
        const casaAccountList = response.data['accountSummaryDetails'].filter((element) =>
          ['U', 'S', 'WA'].includes(element.ACC_TYPE),
        )
        setAccounts(casaAccountList)
        setStage(1)
      }
    } catch (err) {
      setStage(1)
    }
  }, [])

  const getDownload = useCallback(
    async (values) => {
      try {
        setLoading(true)
        await BeneficiaryTransferService.downLoadBiStatement(values)
        setLoading(false)
      } catch (err) {
        var enc = new TextDecoder("utf-8")
        var arr = new Uint8Array(err)
        setLoading(false)
        setError(JSON.parse(enc.decode(arr)))
      }
    },
    [],
  )

  const getAllRefNumbers = useCallback(async () => {
    setLoading(true)
    try {
      const response = await DashboardService.GetListofFormat()
      if (response.status === 200) {
        setLoading(false)
        setReportList(response.data['formatList'])
      }
    } catch (err) {
      setLoading(false)
    }
  })

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderReceiptsViewForm()
      default:
        return renderReceiptsViewForm()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderReceiptsViewForm() {
    return (
      <div>
        <Formik
          initialValues={{
            accountNumber: '',
            fromDate: '',
            toDate: '',
            format: '',
            reportName: '',
          }}
          validationSchema={Yup.object().shape({
            accountNumber: Yup.string().required(t(VALIDATION_MESSAGES.ACCUNT_NO_REQUIRED)),
            fromDate: Yup.date()
              .max(new Date(), t(VALIDATION_MESSAGES.FORM_DATE_VALID))
              .required(t(VALIDATION_MESSAGES.FORM_DATE_REQUIRED)),
            toDate: Yup.date()
              .min(Yup.ref('fromDate'), (t(VALIDATION_MESSAGES.TO_DATE)))
              .max(new Date(), (t(VALIDATION_MESSAGES.TO_DATE_VALID)))
              .required(t(VALIDATION_MESSAGES.TO_DATE_REQUIRED)),
            format: Yup.string().required(t(VALIDATION_MESSAGES.FORMAT)),
            reportName: Yup.string().required(t(VALIDATION_MESSAGES.REPORT_VALID)),
          })}
          onSubmit={getDownload}>
          {({ isSubmitting, errors, touched, handleChange, values }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='1'
                    mode='select'
                    text={t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.ACCOUNTNO)}
                    name='accountNumber'
                    onChange={handleChange}
                    list={accounts}
                    keyValue='ACCOUNT_NO'
                  />
                  <InputError text={errors.accountNumber} touched={touched.accountNumber} />
                </div>
                <div className='form-group col-6'>
                  <NeoInput
                    tabIndex='2'
                    text={t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.FORM_DATE)}
                    name='fromDate'
                    type='date'
                    onChange={handleChange}
                    max={moment(new Date()).format('YYYY-MM-DD')}
                    //value={values.fromDate}
                  />
                  <InputError text={errors.fromDate} touched={touched.fromDate} />
                </div>
                <div className='form-group col-6'>
                  <NeoInput
                    tabIndex='3'
                    text={t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.TO_DATE)}
                    name='toDate'
                    type='date'
                    onChange={handleChange}
                    max={moment(new Date()).format('YYYY-MM-DD')}
                    //value={values.toDate}
                  />
                  <InputError text={errors.toDate} touched={touched.toDate} />
                </div>
                <div className='form-group col-6'>
                  <NeoInput
                    tabIndex='4'
                    mode='select'
                    text={t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.FORMAT)}
                    name='format'
                    onChange={handleChange}
                    keyValue={null}
                    list={formatList}
                  />
                  <InputError text={errors.format} touched={touched.format} />
                </div>

                <div className='form-group col-6'>
                  <NeoInput
                    tabIndex='5'
                    mode='select'
                    text={t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.REPORT_NAME)}
                    name='reportName'
                    onChange={handleChange}
                    keyValue={null}
                    list={reportList}
                  />
                  <InputError text={errors.reportName} touched={touched.reportName} />
                </div>
              </div>

              <div className='mt-3'>
                {loading ? (
                  renderLoading()
                ) : (
                  <NeoButton tabIndex='6' type='submit' text={t(RECIPTS_KEYS.DOWNLOAD)} mode='newDesign' />
                )}
              </div>
              <div className='back-cancel-btn-container'>
              <button className='back-cancel-btn btn btn-sm new-design-warning-text-color' tabIndex={'7'} onClick={() => history.goBack()} >
                {' '}
                {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
              </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='BI' showEmptySpace={true} keyPath={'RECEIPTS'}>
      <div className='new-design-form-style'>
        <div className='heading-style'>{t(MENU_SIDEBAR_KEYS.BI_STATEMENT)}</div>
        {renderSwitch()}
      </div>
    </LayoutWithOutAccountCard>
  )
}
